/*
  Project: Goodie WP
  Author: Urszula Wielgosz
 */

import 'intersection-observer';
import 'loading-attribute-polyfill';

import slider from './modules/slider';
import './modules/menu';
import faq from './modules/faq';
import commentForm from './modules/comment-form';
import sticky from './modules/sticky';

slider();
faq();
commentForm();
sticky();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/goodie-wp-chisel/src/scripts/app.js